"use strict";
exports.__esModule = true;
exports.routes = void 0;
/* This is used by the client to know which routes are exposed */
exports.routes = {
    auth: {
        login: '/login',
        logout: '/logout',
        session: '/session',
        authRedirectUrl: '/auth_redirect'
    },
    docs: {
        upload: '/documents/upload',
        download: '/documents/download',
        list: '/documents/list',
        archive: '/documents/archive'
    },
    transitions: {
        getTransitions: '/transitions',
        addTransition: '/transitions'
    },
    child: {
        getDiagnoses: '/child/assessment/diagnoses',
        upsertDiagnosis: '/child/assessment/diagnoses',
        getFamilyEvalConcerns: '/child/assessment/family-evaluation/concerns',
        updateFamilyEvalConcerns: '/child/assessment/family-evaluation/concerns',
        getFamilyEvalRoutines: '/child/assessment/family-evaluation/routines',
        updateFamilyEvalRoutines: '/child/assessment/family-evaluation/routines',
        getParticipants: '/child/assessment/participants',
        addParticipant: '/child/assessment/participant/add',
        updateParticipant: '/child/assessment/participant/update',
        list: '/child/list',
        show: '/child/show',
        assign: '/child/assign',
        updateDetails: '/child/details',
        updatePrimaryCareProvider: '/child/primary-care-provider',
        getContacts: '/child/contact/getAll',
        addContact: '/child/contact/add',
        updateContact: '/child/contact/update',
        search: '/child/search',
        getFamilyInfo: '/child/family-info',
        updateFamilyInfo: '/child/family-info'
    },
    evaluationsAndAssessments: {
        get: "/evaluations",
        upsert: "/evaluations"
    },
    cos: {
        list: '/cos',
        upsert: '/cos'
    },
    controls: {
        loginAsNewFrc: '/controls/loginAsNewFrc',
        assumeLogin: '/controls/assumeLogin',
        child: {
            createChild: '/controls/child/create-child',
            addContact: '/controls/child/add-contact'
        },
        referral: {
            createReferral: '/controls/referral/create-referral'
        }
    },
    knownDiagnosisTypes: '/known-diagnosis-types',
    referral: {
        create: '/referral/create',
        listByChildId: '/referrals/list-by-child-id'
    },
    serviceDelivery: {
        list: '/track-services/list-tracked-sessions',
        track: '/track-services/track-session'
    },
    organization: {
        findUsersByOrganizationId: '/organizations/find-users-by-organization-id'
    },
    healthcheck: '/healthcheck',
    childOutcomes: {
        get: '/child-outcomes',
        save: '/child-outcomes'
    },
    esitServices: {
        get: '/esit-services',
        save: '/esit-services'
    },
    ifsps: {
        list: '/ifsps',
        upsert: '/ifsps'
    }
};
//# sourceMappingURL=index.js.map